import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroArchiveBox, heroDocument, heroDocumentText, heroMusicalNote, heroPhoto, heroTableCells, heroTrash, heroVideoCamera, heroXMark } from '@ng-icons/heroicons/outline';

@Component({
  selector: 'app-file-uploader',
  standalone: true,
  imports: [CommonModule, MatListModule, MatButtonModule, MatIconModule, NgIcon],
  providers: [provideIcons({
    heroXMark,
    heroTrash,
    heroPhoto,
    heroArchiveBox,
    heroVideoCamera,
    heroMusicalNote,
    heroDocumentText,
    heroDocument,
    heroTableCells
  })],
  templateUrl: './file-uploader.component.html',
  styleUrl: './file-uploader.component.scss'
})
export class FileUploaderComponent {
  constructor(
    private bottomSheetRef: MatBottomSheetRef<FileUploaderComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: { files: File[] }
  ) { }

  getFileIcon(file: File): string {
    if (file.type.startsWith('image/')) return 'heroPhoto';
    if (file.type.startsWith('video/')) return 'heroVideoCamera';
    if (file.type.startsWith('audio/')) return 'heroMusicalNote';
    if (file.type === 'application/pdf') return 'heroDocumentText';
    if (file.type.includes('zip') || file.type.includes('rar')) return 'heroArchiveBox';
    if (file.type.includes('word') || file.type.includes('document')) return 'heroDocument';
    if (file.type.includes('excel') || file.type.includes('spreadsheet')) return 'heroTableCells';
    return 'heroDocument';
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  removeFile(fileToRemove: File) {
    const index = this.data.files.indexOf(fileToRemove);
    if (index > -1) {
      this.data.files.splice(index, 1);
    }
  }

  upload() {
    this.bottomSheetRef.dismiss({ files: this.data.files });
  }

  dismiss() {
    this.bottomSheetRef.dismiss();
  }
}